import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { TagSelector } from '../tag-selector/';
import { addGenre } from '../../api/';
import InputField from '../input-field';
// TODO: fix saving new genre
const GenreSelector = ({disabled, error, label, genres, onChange, selected, zIndex}) => {
	const [selectedGenres, setSelectedGenres] = useState(selected);

	useEffect(() => {
		setSelectedGenres(selected);
	}, [selected]);

	const handleGenreDeselected = (index) => {
		const newGenres = selectedGenres.slice(0);
  	newGenres.splice(index, 1);
		setSelectedGenres(newGenres);
		onChange(newGenres);
  }

	// Make sure there are no duplicates
	const mergeGenres = (oldGenres, newGenre) => {
		if (oldGenres.indexOf(newGenre) >= 0) {
			return;
		}
		return oldGenres.concat([newGenre]);
	}

	const updateSelectedGenres = data => {
		let mergedGenres = mergeGenres(selectedGenres, data.name);
		setSelectedGenres(mergedGenres);
		onChange(mergedGenres);
	}

  const handleGenreSelected = (data) => {
		updateSelectedGenres(data);
  }

	const handleNewGenreAdded = async (data) => {
		await addGenre(data);
		updateSelectedGenres(data);
	}

	const getWrapClassName = () => {
		let appendVal = '';
		if (disabled) {
			appendVal = ' disabled';
		} else if (error) {
			appendVal = ' error'
		}
		return `form-element genre-selector ${appendVal}`
	}

	return (
		<>
		{!disabled ?
			(<div className={getWrapClassName()}>
			{ label && <h2>{label}:</h2> }
				<TagSelector
					assistiveText={{
						createNew: 'Create New Genre',
						addButton: 'Add Genre',
						placeholder: 'Enter a genre name'
					}}
					disabled={disabled}
					items={genres}
					selected={selectedGenres}
					onItemSelected={handleGenreSelected}
					onItemDeselected={handleGenreDeselected}
					onItemAdded={handleNewGenreAdded}
					zIndex={zIndex}
				/>
			</div>) : (
				<InputField
					disabled
					id="genres"
					value={selected.join('/')}
					label={label}
				/>
			)
		}</>
	)
};

GenreSelector.propTypes = {
	label: PropTypes.string,
	genres: PropTypes.array,
	onChange: PropTypes.func,
	selected: PropTypes.array,
	zIndex: PropTypes.number
};

export default GenreSelector;
